import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ScrollIcon, CaretRight } from "@phosphor-icons/react";
import api, { apiErr } from "../api";
import { toast } from "sonner";

const OUTCOME_COLOR = {
  "Critical Success": "text-ff-gold",
  Success: "text-ff-success",
  "Narrow Escape": "text-ff-brass",
  Failure: "text-ff-danger",
  "Major Loss": "text-ff-danger",
};

export default function History() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/history").then((r) => setItems(r.data)).catch((e) => toast.error(apiErr(e)));
  }, []);

  if (!items) return <div className="py-20 text-center text-ff-muted">Opening the logbook...</div>;

  return (
    <div>
      <div className="mb-5 flex items-center gap-2">
        <ScrollIcon size={26} weight="duotone" className="text-ff-gold" />
        <h1 className="font-display text-4xl font-bold tracking-tight">Expedition History</h1>
      </div>

      {items.length === 0 ? (
        <div className="ff-panel rounded-md p-10 text-center text-ff-muted" data-testid="history-empty">
          Your logbook is empty. Complete an expedition to write your first entry.
        </div>
      ) : (
        <div className="space-y-2" data-testid="history-list">
          {items.map((h, i) => (
            <motion.button
              key={h.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.03 }}
              onClick={() => nav(`/history/${h.id}`)}
              data-testid={`history-item-${h.id}`}
              className="ff-panel flex w-full items-center justify-between rounded-md p-4 text-left transition-all hover:-translate-y-0.5 hover:border-ff-gold/40"
            >
              <div className="min-w-0">
                <div className="font-display text-lg font-semibold text-ff-parchment">{h.expedition_name}</div>
                <div className="text-xs text-ff-muted">
                  {new Date(h.date).toLocaleString()} · Stake {h.stake} · Score {h.final_score}
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <div className={`text-sm font-medium ${OUTCOME_COLOR[h.outcome] || "text-ff-parchment"}`}>{h.outcome}</div>
                  <div className={`font-mono-ff text-sm font-bold ${h.gold_result >= 0 ? "text-ff-success" : "text-ff-danger"}`}>
                    {h.gold_result >= 0 ? "+" : ""}{h.gold_result} Gold
                  </div>
                </div>
                <CaretRight size={18} className="text-ff-brass" />
              </div>
            </motion.button>
          ))}
        </div>
      )}
    </div>
  );
}
